import Tiles            from './Tiles/Tiles';
import WeekAhead        from './WeekAhead/WeekAhead';
import WeeklyYear       from './WeeklyYear/WeeklyYear';
import Spread           from './Spread/Spread';
import WeeksAheadWeekly from './WeeksAheadWeekly/WeeksAheadWeekly';
import HonorCard        from './HonorCard/HonorCard';

export { Tiles, WeekAhead, WeeklyYear, Spread, WeeksAheadWeekly, HonorCard };

export const PARNAS_TEMPLATES = [
  {
    id: 'Tiles',
    label: 'שלושת הנציבים',
    description: 'מציג ריבועים זה לצד זה: פרנס היום, פרנס השבוע ופרנס החודש. ניתן לבחור אילו סוגים להציג.\n\n✅ מתאים כשמשתמשים בכמה סוגי פרנסות יחד.\n⚙️ ניתן לשנות: אילו נציבים להציג, צבע הגבול של כל ריבוע, שם ה-placeholder וטקסט ההערה.',
  },
  {
    id: 'WeekAhead',
    label: 'נציב היום | שבוע קדימה',
    description: 'כרטיס גדול ומרכזי עם פרנס היום, ומתחתיו 7 תאים קטנים לשבעת הימים הקרובים — כל תא מציג שם יום, תאריך עברי ושם הפרנס היומי (או "פנוי" אם אין).\n\n✅ מתאים אך ורק לפרנסות יומיות.\n⚙️ ניתן לשנות: שם ה-placeholder לימים ריקים.',
  },
  {
    id: 'WeeksAheadWeekly',
    label: 'נציב השבוע | שבועות קדימה',
    description: 'כרטיס גדול ומרכזי עם פרנס השבוע הנוכחי (פרשה + שם), ומתחתיו רשת של שבועות קדימה — כל תא מציג שם פרשה, תאריך שבת עברי ושם הנציב השבועי (או "פנוי").\n\n✅ מתאים אך ורק לפרנסות שבועיות — מאפשר לראות מי תורם לאילו פרשות בשבועות הקרובים.\n⚙️ ניתן לשנות: מספר השבועות להצגה (4–12).',
  },
  {
    id: 'WeeklyYear',
    label: 'לוח פרשיות השנה',
    description: 'גריד של כל פרשיות השנה העברית (7 עמודות × שורות לפי מספר הפרשות). כל תא מציג שם פרשה, תאריך שבת עברי ושם הפרנס השבועי. הפרשה הנוכחית מודגשת בזהב.\n\n✅ מתאים אך ורק לפרנסות שבועיות.\n⚙️ ניתן לשנות: שנה עברית מוצגת (ברירת מחדל: שנה נוכחית אוטומטית).',
  },
  {
    id: 'Spread',
    label: 'תמונה מלאה | שבוע אחורה וקדימה',
    description: 'התבנית המקיפה ביותר: כרטיס מרכזי מלכותי עם הנציבים הפעילים, מעליו שורת 7 ימים אחורה ומתחתיו שורת 7 ימים קדימה. ניתן לבחור אילו סוגי נציבים להציג בכרטיס המרכזי.\n\n✅ מתאים לכל סוגי הפרנסות יחד.\n⚠️ דורש ווידג\'ט גדול יחסית.',
  },
  {
    id: 'HonorCard',
    label: 'כרטיס כבוד | פרנס בודד',
    description: 'תצוגה מלאה, עשירה ומכובדת לפרנס יחיד — מתאים לפרנס חד-פעמי. שמו של התורם מוצג בולט ומרכזי, וההערה/הטקסט הנוסף שניתן לצרף לפרנס מוצג בגופן גדול ובולט בניגוד לתבניות אחרות.\n\n✅ מתאים לפרנס חד-פעמי ביומי, שבועי או חודשי — הכי מכובד ועשיר.\n⚙️ ניתן לשנות: סדר עדיפויות (איזה סוג נציב להציג כשיש כמה פעילים).',
  },
];

const templates = { Tiles, WeekAhead, WeeklyYear, Spread, WeeksAheadWeekly, HonorCard };

export default templates;
